import {
	useParams,
	useRouteLoaderData,
	useSearchParams,
} from 'react-router-dom';

import { UnitIds } from 'api';
import { resolvedUnitIds, root } from 'main/routes/urls/RouteUrls';

export const useStringParam = (paramName: string): string => {
	const params = useParams();

	// to check if it exists
	if (params[paramName] == null || params[paramName] === '') {
		throw Error(`${paramName} is not a valid.`);
	}

	return params[paramName];
};

export const useResolvedUnitIds = (): UnitIds => {
	const routeLoaderData = useRouteLoaderData(root);
	const unitIds = routeLoaderData[resolvedUnitIds] as UnitIds;
	if (typeof unitIds.id !== 'number' || unitIds.id === 0) {
		throw Error('Id is not a valid.');
	}
	return unitIds;
};

export const useResolvedUnitIdsIfAvailable = (): UnitIds | undefined => {
	try {
		return useResolvedUnitIds();
	} catch {
		return undefined;
	}
};

export const useNumberParam = (paramName: string): number => {
	const params = useParams();
	const unitIdParsed = Number(params[paramName]);

	// to check if it's an integer number excluding float
	if (unitIdParsed === 0 || isNaN(unitIdParsed) || unitIdParsed % 1 !== 0) {
		throw Error('Id is not a valid.');
	}

	return unitIdParsed;
};

export const useStringSearchParam = (paramName: string): string => {
	const [params] = useSearchParams();
	const param = params.get(paramName);

	// to check if it exists
	if (param == null || param === '') {
		throw Error(`${paramName} is not a valid.`);
	}

	return param;
};

export const useNumberSearchParam = (paramName: string): number => {
	const [params] = useSearchParams();
	const param = params.get(paramName);
	const unitIdParsed = Number(param);

	// to check if it's an integer number excluding float
	if (unitIdParsed === 0 || isNaN(unitIdParsed) || unitIdParsed % 1 !== 0) {
		throw Error('Id is not a valid.');
	}

	return unitIdParsed;
};
